import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const InAppDelivery = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M17.3201 7.18994V2.68994C17.3201 2.39157 17.2015 2.10542 16.9906 1.89445C16.7796 1.68347 16.4934 1.56494 16.1951 1.56494H2.69507C2.3967 1.56494 2.11055 1.68347 1.89957 1.89445C1.68859 2.10542 1.57007 2.39157 1.57007 2.68994V15.0649C1.57007 15.3633 1.68859 15.6495 1.89957 15.8604C2.11055 16.0714 2.3967 16.1899 2.69507 16.1899H7.19507"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.57007 4.93994H17.3201"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4281 8.76168L19.2253 10.7019C19.4371 10.8117 19.6144 10.9777 19.7379 11.1817C19.8614 11.3858 19.9261 11.6199 19.9251 11.8584V16.0794C19.9261 16.3179 19.8614 16.5521 19.7379 16.7561C19.6144 16.9602 19.4371 17.1262 19.2253 17.2359L15.4281 19.1762C15.253 19.266 15.059 19.3129 14.8622 19.3129C14.6654 19.3129 14.4714 19.266 14.2963 19.1762L10.4991 17.2359C10.2875 17.126 10.1103 16.96 9.98701 16.7559C9.86369 16.5519 9.79901 16.3178 9.80006 16.0794V11.8584C9.799 11.6199 9.86376 11.3858 9.98722 11.1817C10.1107 10.9777 10.2881 10.8117 10.4998 10.7019L14.2963 8.76168C14.4714 8.67185 14.6654 8.625 14.8622 8.625C15.059 8.625 15.253 8.67185 15.4281 8.76168V8.76168Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99951 11.1611L14.8625 13.6459L19.7248 11.1611"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8625 13.6455V19.3125"
      stroke="#3D3A3B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
